import axios from 'axios'

// Hardcoded to production (not the per-environment restful.URL) since this
// endpoint's data (real host ratings/reviews) only exists meaningfully in
// production - staging/local Mongo doesn't carry real review content.
const TOP_HOSTS_API_URL = 'https://prod.k8s.haupcar.com/ts-restful-api'

export interface TopHostReview {
  reviewerName: string
  rating: number
  text: string
  pictureList: string[]
  createdAt: string
}

export interface TopHost {
  hostUserId: number
  hostCode: string
  name: string
  avatarUrl: string | null
  isVerified: boolean
  vehicleDisplay: string
  city: string | null
  rating: number
  reviewCount: number
  completedTrips: number
  reviews: TopHostReview[]
}

interface GetTopHostsResponse {
  result: boolean
  data: TopHost[]
}

// Public endpoint (no auth required) - safe to call from pre-login pages.
// Returns a curated, fixed list of featured hosts (see FEATURED_HOST_USER_IDS
// in ts-restful-api's profile.service.ts).
export async function getTopHosts(): Promise<TopHost[]> {
  const response = await axios.get<GetTopHostsResponse>(
    `${TOP_HOSTS_API_URL}/mobile/profile/hosts/top-rated`,
  )
  return response.data.data
}
